module.exports = require("gsap/umd/TweenMax");


//////////////////
// WEBPACK FOOTER
// external "gsap/umd/TweenMax"
// module id = 23
// module chunks = 0